import { useDynamicPageContext } from '../../contexts/DynamicPageContext';
import { ExperimentsHubContent } from '../ExperimentsHub/ExperimentsHubContent';

/**
 * Experiments tab within ManageDynamicPage.
 * Shows ExperimentsHub filtered to the current dynamic page.
 */
export default function ManageDynamicPageExperiments() {
  const { selectedDynamicPage } = useDynamicPageContext();

  return (
    <ExperimentsHubContent
      dynamicPageId={selectedDynamicPage?.id}
      showHeader={false}
    />
  );
}
